const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.fbb-container');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
        })
        .catch(e => {
            console.error(e);
        });
};

const productRecommendationsSection = document.querySelector('.fbb-container');
const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

observer.observe(productRecommendationsSection);

function fbbAdd(btn) {
    btn.disabled = true
    let variantId = btn.getAttribute("data-fbb-variant-id")

    let formData = {
        "items": []
    };

    formData['items'].push({"id": variantId, "quantity": 1, properties: {}})

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(res => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        btn.disabled = false;
    }).catch((error) => {
        btn.disabled = false
        console.error('Error:', error);
    });
}

function fbbInputChange(radio) {
    const name = radio.getAttribute("name")
    const productId = radio.getAttribute("data-fbb-product-id")
    const allInputsForRadio = document.querySelectorAll("[name=" + CSS.escape(name) + "]");
    const addButton = document.getElementById(`FBB-${productId}-add`)
    addButton.disabled = false

    allInputsForRadio.forEach(v => {
        v.checked = false
    })

    radio.checked = true;

    const options = []
    document.querySelectorAll("[data-fbb-product-id=" + CSS.escape(productId) + "]").forEach(v => {
        if (v.checked) {
            options.push(v.value)
        }
    })

    const selector = options.reverse().join("-")
    let selected = null
    document.querySelectorAll("[data-fbb-select-product-id=" + CSS.escape(productId) + "]")
        .forEach(v => {
            v.checked = false;
            if (v.getAttribute("data-fbb-select") === selector) {
                selected = v
            }
        })

    if (selected == null) {
        addButton.disabled = true
        addButton.setAttribute("data-fbb-variant-id", null)
    } else {
        addButton.setAttribute("data-fbb-variant-id", selected.value)
        const img_url = selected.getAttribute("data-fbb-select-img-url")
        if (img_url != null) {
            const img = document.getElementById(`FBB-${productId}-img`)
            img.src = img_url
        }
    }
}